export * from './skill.component';



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/skill.component/index.ts